import {AxiosInstance} from './api';

export const getMonthlyEmailSetting = async (id = 1) => {
  try {
    let response = await AxiosInstance.get(`/config/monthlyemail/${id}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};

export const updateMonthlyEmailSetting = async (data, id = 1) => {
  try {
    let response = await AxiosInstance.put(`/config/monthlyemail/update/${id}`, {
      ...data,
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};
